module.exports = __webpack_public_path__ + "img/Weapon_243.93cc46c6.png";